<style scoped>

.wrapper {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

@keyframes lds-spin {
    0% {
        opacity: 1;
        -webkit-transform: scale(1.2, 1.2);
        transform: scale(1.2, 1.2);
    }
    100% {
        opacity: 0;
        -webkit-transform: scale(1, 1);
        transform: scale(1, 1);
    }
}

@-webkit-keyframes lds-spin {
    0% {
        opacity: 1;
        -webkit-transform: scale(1.2, 1.2);
        transform: scale(1.2, 1.2);
    }
    100% {
        opacity: 0;
        -webkit-transform: scale(1, 1);
        transform: scale(1, 1);
    }
}

.lds-spin {
    position: relative;
}

.lds-spin div > div {
    position: absolute;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #ac0f28;
    -webkit-animation: lds-spin 1s linear infinite;
    animation: lds-spin 1s linear infinite;
}

.lds-spin div:nth-child(1) > div {
    left: 164px;
    top: 84px;
    -webkit-animation-delay: -0.9s;
    animation-delay: -0.9s;
}

.lds-spin > div:nth-child(1) {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transform-origin: 180px 100px;
    transform-origin: 180px 100px;
}

.lds-spin div:nth-child(2) > div {
    left: 148.72135952000002px;
    top: 131.02282015999998px;
    -webkit-animation-delay: -0.8s;
    animation-delay: -0.8s;
}

.lds-spin > div:nth-child(2) {
    -webkit-transform: rotate(36deg);
    transform: rotate(36deg);
    -webkit-transform-origin: 164.72135952000002px 147.02282015999998px;
    transform-origin: 164.72135952000002px 147.02282015999998px;
}

.lds-spin div:nth-child(3) > div {
    left: 108.72135952px;
    top: 160.08452128px;
    -webkit-animation-delay: -0.7s;
    animation-delay: -0.7s;
}

.lds-spin > div:nth-child(3) {
    -webkit-transform: rotate(72deg);
    transform: rotate(72deg);
    -webkit-transform-origin: 124.72135952px 176.08452128px;
    transform-origin: 124.72135952px 176.08452128px;
}

.lds-spin div:nth-child(4) > div {
    left: 59.27864048000001px;
    top: 160.08452128px;
    -webkit-animation-delay: -0.6s;
    animation-delay: -0.6s;
}

.lds-spin > div:nth-child(4) {
    -webkit-transform: rotate(108deg);
    transform: rotate(108deg);
    -webkit-transform-origin: 75.27864048px 176.08452128px;
    transform-origin: 75.27864048px 176.08452128px;
}

.lds-spin div:nth-child(5) > div {
    left: 19.278640479999993px;
    top: 131.02282015999998px;
    -webkit-animation-delay: -0.5s;
    animation-delay: -0.5s;
}

.lds-spin > div:nth-child(5) {
    -webkit-transform: rotate(144deg);
    transform: rotate(144deg);
    -webkit-transform-origin: 35.27864047999999px 147.02282015999998px;
    transform-origin: 35.27864047999999px 147.02282015999998px;
}

.lds-spin div:nth-child(6) > div {
    left: 4px;
    top: 84px;
    -webkit-animation-delay: -0.4s;
    animation-delay: -0.4s;
}

.lds-spin > div:nth-child(6) {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
    -webkit-transform-origin: 20px 100px;
    transform-origin: 20px 100px;
}

.lds-spin div:nth-child(7) > div {
    left: 19.278640479999993px;
    top: 36.977179840000005px;
    -webkit-animation-delay: -0.3s;
    animation-delay: -0.3s;
}

.lds-spin > div:nth-child(7) {
    -webkit-transform: rotate(216deg);
    transform: rotate(216deg);
    -webkit-transform-origin: 35.27864047999999px 52.977179840000005px;
    transform-origin: 35.27864047999999px 52.977179840000005px;
}

.lds-spin div:nth-child(8) > div {
    left: 59.27864048000001px;
    top: 7.91547872000001px;
    -webkit-animation-delay: -0.2s;
    animation-delay: -0.2s;
}

.lds-spin > div:nth-child(8) {
    -webkit-transform: rotate(252deg);
    transform: rotate(252deg);
    -webkit-transform-origin: 75.27864048px 23.91547872000001px;
    transform-origin: 75.27864048px 23.91547872000001px;
}

.lds-spin div:nth-child(9) > div {
    left: 108.72135952px;
    top: 7.91547872000001px;
    -webkit-animation-delay: -0.1s;
    animation-delay: -0.1s;
}

.lds-spin > div:nth-child(9) {
    -webkit-transform: rotate(288deg);
    transform: rotate(288deg);
    -webkit-transform-origin: 124.72135952px 23.91547872000001px;
    transform-origin: 124.72135952px 23.91547872000001px;
}

.lds-spin div:nth-child(10) > div {
    left: 148.72135952000002px;
    top: 36.977179840000005px;
    -webkit-animation-delay: 0s;
    animation-delay: 0s;
}

.lds-spin > div:nth-child(10) {
    -webkit-transform: rotate(324deg);
    transform: rotate(324deg);
    -webkit-transform-origin: 164.72135952000002px 52.977179840000005px;
    transform-origin: 164.72135952000002px 52.977179840000005px;
}

.lds-spin div:nth-child(11) > div {
    left: 164px;
    top: 84px;
    -webkit-animation-delay: 0.1s;
    animation-delay: 0.1s;
}

.lds-spin > div:nth-child(11) {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
    -webkit-transform-origin: 180px 100px;
    transform-origin: 180px 100px;
}

.lds-spin {
    width: 100px !important;
    height: 100px !important;
    -webkit-transform: translate(-50px, -50px) scale(0.5) translate(50px, 50px);
    transform: translate(-50px, -50px) scale(0.5) translate(50px, 50px);
}

</style>

<template>

<v-flex class="wrapper" xs12 v-if="loading">

    <div class="lds-css ng-scope">
        <div class="lds-spin" style="width:100%;height:100%">
            <div>
                <div></div>
            </div>
            <div>
                <div></div>
            </div>
            <div>
                <div></div>
            </div>
            <div>
                <div></div>
            </div>
            <div>
                <div></div>
            </div>
            <div>
                <div></div>
            </div>
            <div>
                <div></div>
            </div>
            <div>
                <div></div>
            </div>
            <div>
                <div></div>
            </div>
            <div>
                <div></div>
            </div>
        </div>
    </div>

    <!-- <img style="height:100px; width:auto;" :src="baseUrl" /> -->
</v-flex>

</template>

<script>

export default {
    props: [],
    data() {
        return {
            baseUrl: null,
            loading: false
        };
    },
    created() {
        EventBus.$on("loading", e => {
            this.loading = e;
        });
        this.baseUrl = window.location.origin + "/images/loading.gif";
    },
    methods: {}
};

</script>
